/* eslint-disable max-lines */
/* eslint-disable max-len */

import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { ITripType } from "../../../interfaces/endpoints/trips/Trips.types";
import Button from "../../ui/Button";
import Modal from "../../ui/Modal";
import SuperAdmin from "../../users/permissions/SuperAdmin";

const CommissionFeeInput: React.FC = () => {
  const { formState: { errors }, setValue, watch } = useFormContext<ITripType>();
  const entityCommissionFee = watch("entityCommissionFee");
  const [showModal, setShowModal] = useState(false);
  const [tempValue, setTempValue] = useState("");

  useEffect(() => {
    if (!entityCommissionFee?.fee && entityCommissionFee?.fee !== 0) {
      setValue("entityCommissionFee", null);
      return;
    }

    if (entityCommissionFee?.fee !== undefined
      && entityCommissionFee.fee !== null
      && entityCommissionFee.fee < 100
      && Number((entityCommissionFee.fee * 100).toFixed(4)) < 100
    ) {
      const percentageValue = Number((entityCommissionFee.fee * 100).toFixed(4));
      setValue("entityCommissionFee.fee", percentageValue, { shouldValidate: true });
      setTempValue(percentageValue.toString());
    }
  }, [entityCommissionFee]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key === "Tab" ||
      e.key === "Escape" ||
      e.key === "Enter" ||
      e.key === "."
    ) {
      if (e.key === "." && (e.target as HTMLInputElement).value.includes(".")) {
        e.preventDefault();
      }
      return;
    }

    if (!/[\d]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;

    value = value.replace(/[^\d.]/g, "");

    const parts = value.split(".");
    if (parts.length > 2) {
      value = parts[0] + "." + parts.slice(1).join("");
    }

    if (value.includes(".")) {
      const [whole, decimal] = value.split(".");
      value = `${whole}.${decimal.slice(0, 4)}`;
    }

    setTempValue(value);
  };

  const handleSave = () => {
    if (!tempValue) {
      setValue("entityCommissionFee", null);
    } else {
      setValue("entityCommissionFee.fee", Number(tempValue), { shouldValidate: true });
    }
    setShowModal(false);
  };

  return (
    <SuperAdmin>
      <div className="flex flex-col space-y-2">
      <button
        type="button"
        className="text-primary flex items-center
        transitions hover:font-semibold cursor-pointer transition-all duration-75"
        onClick={() => setShowModal(true)}
      >
        Dëshironi të ndryshoni komisionin e operatorit për këtë orar specifik?
      </button>
        {entityCommissionFee?.fee !== undefined && entityCommissionFee?.fee !== null && (
          <p className="text-sm text-gray-600">
            Komisioni aktual: {entityCommissionFee.fee}%
          </p>
        )}
      </div>

      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        position="center"
        title="Ndrysho komisionin e orarit"
        buttonElement={
          <Button onClick={handleSave}>
            Ruaj
          </Button>
        }
      >
        <div className="p-6">
        <p className="mb-4 text-sm text-gray-500">
            Vendosni një vlerë midis 0.00% dhe 100.00% për të ndryshuar komisionin e operatorit vetëm për këtë orar.
          </p>
          <div className="relative">
            <input
              type="text"
              value={tempValue}
              onKeyDown={handleKeyDown}
              onChange={handleChange}
              placeholder="0.00"
              className={`block w-full px-3 py-2.5 border ${
                errors.entityCommissionFee?.fee ? "border-red-500" : "border-gray-300"
              } rounded-lg shadow-sm focus:ring-primary focus:border-primary sm:text-sm`}
            />
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <span className="text-gray-500">%</span>
            </div>
          </div>
          {errors.entityCommissionFee?.fee && (
            <p className="mt-2 text-sm text-red-500">
              {errors.entityCommissionFee.fee.message}
            </p>
          )}
          <p className="mt-4 text-sm text-red">
            Nese nuk vendosni asnjë vlerë, atëherë do të përdoret komisioni i paracaktuar i operatorit.
          </p>
        </div>
      </Modal>
    </SuperAdmin>
  );
};

export default CommissionFeeInput;
